<template>
  <!-- <v-overlay app :value="isLoading" transition="fade">
    <v-progress-circular indeterminate size="360" color="primary"
      ><span style="color:white;">{{ quote }}...</span>
    </v-progress-circular>
  </v-overlay> -->
  <div
    app
    v-if="isLoading"
    style="position: absolute;
    right: 20px;
    bottom: 30px;"
    transition="fade"
    heigth="100vh"
  >
    <v-progress-circular indeterminate size="46" color="primary">
    </v-progress-circular>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      quote: "",
      quotes: this.$t("quotes"),
      quotelist: []
    };
  },
  methods: {
    changeQuote() {
      this.quotelist = this.quotelist
        .slice(1, this.quotelist.length)
        .concat(this.quotelist.slice(0, 1));
      this.quote = this.quotelist[0];
      let that = this;
      setTimeout(function() {
        that.changeQuote();
      }, 6000);
    }
  },
  created() {
    this.quotelist = this.quotes.split("|");
    this.changeQuote();
  },
  computed: {
    isLoading() {
      return this.$store.state.promiseLoading;
    }
  }
};
</script>

<style></style>
